import React, { useCallback, useEffect, useState } from 'react';

import { Redirect } from 'react-router-dom';

import { FiEdit } from 'react-icons/fi';

import Button from '../../../../components/Global/Button';
import ModalAddBranch from '../../../../components/Admin/Modal/ModalAddBranch';
import ModalEditBranch from '../../../../components/Admin/Modal/ModalEditBranch';

import {
  Container,
  CardeHeader,
  CardButton,
  CardGraphic,
  GraphicTitle,
  CardGraphicText,
} from './styles';
import { api } from '../../../../services/api';
import { useAuth } from '../../../../hooks/auth';

export interface IBranch {
  id: string;
  full_name: string;
  short_name: string;
  cnpj: string;
  address: string;
  short_address: string;
}

const Branch: React.FC = () => {
  const { user } = useAuth();

  const [modalOpen, setModalOpen] = useState(false);
  const [modalEditOpen, setModalEditOpen] = useState(false);

  const [branches, setBranches] = useState<IBranch[]>([]);
  const [dataEditBranch, setDataEditBranch] = useState<IBranch>();

  const loadBranches = useCallback(() => {
    api
      .get<IBranch[]>('/branches')
      .then(response => {
        setBranches(response.data);
      })
      .catch(err => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    loadBranches();
  }, [loadBranches]);

  const toggleModal = useCallback(() => {
    setModalOpen(!modalOpen);
  }, [modalOpen]);

  const toggleModalEdit = useCallback(() => {
    setModalEditOpen(!modalEditOpen);
  }, [modalEditOpen]);

  const handleEdit = useCallback((branch: IBranch) => {
    setDataEditBranch(branch);
    setModalEditOpen(true);
  }, []);

  if (user.tag !== 'admin') {
    return <Redirect to="/menu" />;
  }

  return (
    <>
      <ModalAddBranch
        isOpen={modalOpen}
        setIsOpen={toggleModal}
        handleBranch={loadBranches}
      />
      <ModalEditBranch
        isOpen={modalEditOpen}
        setIsOpen={toggleModalEdit}
        handleBranch={loadBranches}
        dataEditBranch={dataEditBranch}
      />

      <Container>
        <CardeHeader>
          <div>
            <h2>Filiais</h2>
            <strong>Gerencie as filiais da cooperativa.</strong>
          </div>

          <CardButton>
            <div>
              <Button
                onClick={toggleModal}
                type="button"
                groud={false}
                disabled={false}
                isUsed={false}
              >
                Adicionar nova filial
              </Button>
            </div>
          </CardButton>
        </CardeHeader>

        {branches.map(branch => (
          <CardGraphic key={branch.id}>
            <CardGraphicText>
              <GraphicTitle>
                <h3>{branch.short_name}</h3>

                <p>{branch.full_name}</p>

                <p>
                  CNPJ:
                  {` ${branch.cnpj || '-'}`}
                </p>
              </GraphicTitle>
              <span>
                <FiEdit onClick={() => handleEdit(branch)} />
              </span>
            </CardGraphicText>
          </CardGraphic>
        ))}
      </Container>
    </>
  );
};

export default Branch;
